import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate } from '../../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../../utils/constants';
import { checkPermission } from '../../../../services/auth';

const ListItemInventoryGeneral = (props) => {
    let disable = false;
    const manageInventory = checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.LoadInventory : PERMISSIONS.Inventory.Rotative.LoadInventory);
    const getStatus = (value) => translate(enumText(ENUMS.eInventoryStatus, value), 'inventory');

    const onClickRefresh = (event) => {
        if (!disable) {
            disable = true;
            event.preventDefault();
            setTimeout(() => { disable = false; }, 5000);
            props.onRefreshInventory();
        }
    };

    return (
        <>
            {(manageInventory === true && Number(props.data.status) !== ENUMS.eInventoryStatus.Loading.value) ? (
                <span
                    id="refresh"
                    className="title sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '30px', right: '45px', zIndex: '999' }}
                    onClick={(event) => { onClickRefresh(event); }}
                ><i className="mdi mdi-cached" style={{ cursor: 'pointer' }} />
                </span>
            )
                : null}
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">{`${props.data.code}`}</span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}> {props.data.name} </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    {getStatus(props.data.status)} | <b>{props.data && props.data.lots ? `${props.data.lots.reduce((sum, item) => (Number(item.status) === ENUMS.eInventoryLotStatus.Finished.value || Number(item.status) === ENUMS.eInventoryLotStatus.Canceled.value ? sum += 1 : sum += 0), 0)}/${props.data.lots.reduce((sum, item) => (Number(item.status) !== ENUMS.eInventoryLotStatus.Waiting.value
                        && Number(item.status) !== ENUMS.eInventoryLotStatus.Loading.value ? sum += 1 : sum += 0), 0)}` : null}
                    </b>
                </span>
                {props.data && props.data.lots ? (
                    <span className="progress" style={{ backgroundColor: '#acccec', marginBottom: '5px', display: Number(props.data.status) === ENUMS.eInventoryStatus.Loading.value ? 'flex' : 'none' }}>
                        <div
                            className="determinate"
                            style={{
                                width: `${(100 / props.data.lots.length)
                                    * props.data.lots.reduce((sum, item) => (Number(item.status) !== ENUMS.eInventoryLotStatus.Waiting.value
                                        && Number(item.status) !== ENUMS.eInventoryLotStatus.Loading.value ? sum += 1 : sum += 0), 0)}%`,
                                backgroundColor: 'var(--third-text-color)'
                            }}
                        />
                    </span>
                ) : null}
            </Link>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(ListItemInventoryGeneral)));
